import { render, staticRenderFns } from "./InterestingEdit.vue?vue&type=template&id=3c7b33e2"
import script from "./InterestingEdit.vue?vue&type=script&lang=js"
export * from "./InterestingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports